import React, { useContext, useEffect, useRef } from 'react';
import { useInView } from 'framer-motion';

import video_white from '../../../assets/videos/logistics/bg_w.mp4';
import video_black from '../../../assets/videos/logistics/bg_b.mp4';
import './Logistics.css';
import { THEME_LIGHT_TYPE } from '../../../assets/utils/constants';
import { ThemeContext } from '../../../assets/contexts/themeContext';
import { TranslationContext } from '../../../assets/contexts/translationContext';

function Logistics() {
    const { mainPbl } = useContext(TranslationContext);
    const { mainLogistic } = mainPbl;

    const videoRef = useRef(null);
    const isInView = useInView(videoRef, { once: true, margin: '-100px' });
    const { theme } = useContext(ThemeContext);

    // Unlock video for autoplay on iOS
    useEffect(() => {
        const video = videoRef.current;
        if (!video) return;

        const unlockVideoAutoplay = () => {
            video.play().then(() => video.pause()).catch((error) => {
                console.error("Error trying to unlock video autoplay:", error);
            });

            document.removeEventListener('touchstart', unlockVideoAutoplay);
            document.removeEventListener('click', unlockVideoAutoplay);
        };

        document.addEventListener('touchstart', unlockVideoAutoplay);
        document.addEventListener('click', unlockVideoAutoplay);

        return () => {
            document.removeEventListener('touchstart', unlockVideoAutoplay);
            document.removeEventListener('click', unlockVideoAutoplay);
        };
    }, []);

    // Play the video when it comes into view
    useEffect(() => {
        const video = videoRef.current;
        if (video && isInView) {
            video.play().catch((error) => {
                console.error("Error trying to play the video:", error);
            });
        }
    }, [isInView]);

    const handleVideoError = (e) => {
        console.error("Video error event:", e);
        console.error("Native event details:", e.nativeEvent);
    };
    // console.log(theme)

    return (
        <div className='logistics' id='benefits' data-section>
            <h3 className='logistics__title'>
                <svg className='logistics__title__smile-icon' xmlns="http://www.w3.org/2000/svg" width="91" height="91" viewBox="0 0 91 91" fill="none">
                    <path d="M45.5 79.625C64.3467 79.625 79.625 64.3467 79.625 45.5C79.625 26.6533 64.3467 11.375 45.5 11.375C26.6533 11.375 11.375 26.6533 11.375 45.5C11.375 64.3467 26.6533 79.625 45.5 79.625Z" fill="#2BBC5D" stroke="#2BBC5D" stroke-width="1.4734" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M47.6707 52.6053H53.6007V26H47.6707V52.6053ZM37.4476 52.6053H43.3776V26H37.4476V52.6053ZM29.251 56.0574L31.5661 54.9067C32.4824 54.4638 33.1081 54.1989 33.5905 54.1989C34.3615 54.1989 34.7954 54.7307 35.4232 55.4386C37.0621 57.2526 40.005 59.9988 45.501 59.9988C50.997 59.9988 53.9399 57.2545 55.5788 55.4386C56.2065 54.7307 56.6405 54.1989 57.4115 54.1989C57.8939 54.1989 58.5195 54.4638 59.4359 54.9067L61.751 56.0574C57.7001 62.8746 51.6248 65 45.501 65C39.3772 65 33.3019 62.8746 29.251 56.0574Z" fill="white" />
                </svg>

                {mainLogistic.titleFirstLine} <br />{mainLogistic.titleSecondLine}</h3>
            <p className='logistics__subtitle'>{mainLogistic.subtitle}</p>

            {theme === THEME_LIGHT_TYPE ?
                <video
                    key={'logistics__video_video_white'}
                    className='logistics__video'
                    ref={videoRef}
                    src={video_white} // Source set directly
                    loop
                    autoPlay
                    muted
                    playsInline
                    preload="metadata"
                    onError={handleVideoError}
                >
                    {mainLogistic.errorVideo}
                </video>
                :
                <video
                    key={'logistics__video_video_black'} // Unique key changes with theme
                    className='logistics__video logistics__video_video_black'
                    ref={videoRef}
                    src={video_black} // Source set directly
                    loop
                    autoPlay
                    muted
                    playsInline
                    preload="metadata"
                    onError={handleVideoError}
                >
                    {mainLogistic.errorVideo}
                </video>
            }
        </div>
    );
}

export default Logistics;
